"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerCoupon = require("@/api/activity/customerCoupon");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'customerCouponConfig',
  data: function data() {
    return {
      form: {
        id: '',
        staffPerIssueLimit: 1,
        staffMultiUserLimit: 1,
        userStoreLimitDays: '',
        userStoreLimitCount: '',
        userGlobalLimitDays: '',
        userGlobalLimitCount: ''
      },
      rules: {
        staffPerIssueLimit: [{
          required: true,
          message: '请输入员工每次发券数量',
          trigger: 'blur'
        }],
        staffMultiUserLimit: [{
          required: true,
          message: '请输入员工多人发用户数量',
          trigger: 'blur'
        }],
        userStoreLimitDays: [{
          required: true,
          message: '请输入同用户同门店X天内可领取',
          trigger: 'blur'
        }],
        userStoreLimitCount: [{
          required: true,
          message: '可领取X次门店券不能为空',
          trigger: 'blur'
        }],
        userGlobalLimitDays: [{
          required: true,
          message: '请输入同用户X天内可领取',
          trigger: 'blur'
        }],
        userGlobalLimitCount: [{
          required: true,
          message: '请输入同用户同门店可领取X次门店券',
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  mounted: function mounted() {
    this.queryConfig();
  },
  methods: {
    // 查询配置
    queryConfig: function queryConfig() {
      var _this = this;
      this.loading = true;
      (0, _customerCoupon.getCouponConfig)().then(function (res) {
        if (res.code === 200 && res.data) {
          _this.form = res.data;
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 保存配置
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          (0, _customerCoupon.saveOrUpdCouponConfig)(_this2.form).then(function (res) {
            if (res.code === 200) {
              _this2.$message.success('保存配置成功');
            } else {
              _this2.$message.error(res.msg || '保存配置失败');
            }
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    },
    // 重置表单
    handleReset: function handleReset() {
      this.$refs.formRef.resetFields();
      this.queryConfig();
    }
  }
};